import React from 'react';
import $ from 'jquery';

import {
  Form,
  Button,
} from 'react-bootstrap';

export default class XeditableManyToManyField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      refresh: undefined,
      initial_values: [],
      data: {},
      ready: false,
    }
  }

  componentDidMount = () => {

    let initial_values = []
    let data_initial = JSON.parse(this.props.data_initial);
    for (var key in data_initial) {
      initial_values.push(data_initial[key]['id']);
    }
    initial_values = JSON.stringify(initial_values)

    let data = $(`.${this.props.reference}`).data('initial')
    let current_values = []
    for (var key in data) {
      var newOption = new Option(data[key].text, data[key].id, false, false);
      $(`.${this.props.reference}`).append(newOption);
      current_values.push(data[key].id);
    }

    this.setState({initial_values})

    $(`.${this.props.reference}`).trigger('change');
    setTimeout(() => this.renderEditable(), 500 );
  }

  componentWillReceiveProps = (nextProps) => {
    console.log('componentReceiveProps');
    setTimeout(() => this.renderEditable(), 500 );
  }

  renderEditable = () => {
    $(`.${this.props.reference}`).editable({
        mode: 'inline',
        type: 'Select2',
        select2: {
            multiple: true,
            ajax: {
              context: this,
              url: '/api/x/americorps/members/',
              results: function (data) {
                  console.log('Data');
                  console.log(data)
                  console.log({results: data})
                  console.log(this)
                  let initial_values = []
                  let data_initial = JSON.parse(this.context.props.data_initial);
                  for (var key in data_initial) {
                    initial_values.push(data_initial[key]['id']);
                  }
                  let new_data = {}
                  for (var key in data) {
                    let record = data[key];
                    if (initial_values.includes(record.id)) {
                      record['selected'] = true;
                    }
                  }
                  console.log(data);
                  return {
                    results: data
                  };
              }
            }
        },

        success: function(response, newValue) {
            console.log('NewValue');
            console.log(newValue);
            console.log($(this));
            $(this).data('current-values', newValue);
          },

          // display: function(value) {
          //     if (value) {
          //         $.each(value,function(i){value[i] = $('<p>' + value[i] + '</p>').text()});
          //         $(this).html(value.join(" "));
          //     }
          // }
    });
  }

  render() {

    return (
        <span
            className={`${this.props.reference}`}
            data-type={"select2"}
            id={this.props.reference}
            data-pk={this.props.reference}
            key={this.props.reference}
            data-initial={this.props.data_initial}
            data-original-title={this.props.original_title}
            data-current-values={this.state.initial_values}
        >
        </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/xeditable/xeditable_many_to_many_field.js